import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Row, Container, CardBody, Col, Card } from 'reactstrap';
import MatTable from '../../../../shared/components/material-table';
import ColumnsForVisualizationMetrics from './ColumnsForVisualizationMetrics';
import LegendHandlers from '../../../../shared/components/LegendHandlers';
import { formatterPercentPieChartDataSet } from '../../../../shared/utils/smartutils';
import { COMMUNICATION_TYPE } from '../../../../shared/utils/constants';

const VisualizationMetricsView = ({
  t,
  communicationType,
  visualizationMetricsWrapper,
}) => {
  const labelsChart = [t('general.viewed'), t('general.not-viewed')];

  const options = {
    plugins: {
      datalabels: {
        formatter: formatterPercentPieChartDataSet,
        color: 'white',
        anchor: 'center',
        align: 'center',
        offset: 10,
      },
    },
  };

  const getResultDataStudent = () => {
    return visualizationMetricsWrapper.communicationResultsAlun
      ? [
          visualizationMetricsWrapper.communicationResultsAlun.viewed,
          visualizationMetricsWrapper.communicationResultsAlun.notViewed,
        ]
      : [];
  };

  const getResultDataResponsible = () => {
    return visualizationMetricsWrapper.communicationResultsResp
      ? [
          visualizationMetricsWrapper.communicationResultsResp.viewed,
          visualizationMetricsWrapper.communicationResultsResp.notViewed,
        ]
      : [];
  };

  return (
    <Container>
      <Row>
        {communicationType !== COMMUNICATION_TYPE.AUTHORIZATION && (
          <div className="w-50">
            <LegendHandlers
              dataLabels={labelsChart}
              numbersChart={getResultDataStudent()}
              chartTitle={t('communication.viewsByStudent')}
              options={options}
            />
          </div>
        )}
        <div className="w-50">
          <LegendHandlers
            dataLabels={labelsChart}
            numbersChart={getResultDataResponsible()}
            chartTitle={t('communication.viewsByResponsible')}
            options={options}
          />
        </div>
      </Row>
      <Row className="Table">
        <Col md={12} lg={12}>
          <Card>
            <CardBody className="material-table-card">
              <div className="material-table__wrap">
                <MatTable
                  data={visualizationMetricsWrapper.communicationResultsDetail}
                  columns={ColumnsForVisualizationMetrics(t, communicationType)}
                  paging={false}
                  group
                />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

VisualizationMetricsView.propTypes = {
  t: PropTypes.func.isRequired,
  visualizationMetricsWrapper: PropTypes.shape({
    communicationResultsDetail: PropTypes.shape({
      studentId: PropTypes.number,
      studentName: PropTypes.string,
      classesNames: PropTypes.string,
      responsibleName: PropTypes.string,
      responsiblePhone: PropTypes.string,
      responsibleEmail: PropTypes.string,
      viewed: PropTypes.bool,
      previewDate: PropTypes.number,
      viewedBy: PropTypes.string,
      answer: PropTypes.bool,
      answerDate: PropTypes.number,
    }),
    communicationResultsResp: PropTypes.shape({
      viewed: PropTypes.number,
      notViewed: PropTypes.number,
    }),
    communicationResultsAlun: PropTypes.shape({
      viewed: PropTypes.number,
      notViewed: PropTypes.number,
    }),
  }).isRequired,
  communicationType: PropTypes.string.isRequired,
};

export default withTranslation('common')(VisualizationMetricsView);
